import React from 'react';
import { Navigate, useRoutes } from 'react-router-dom';

import { authRoutes } from './auth';
import { dashboardRoutes } from './dashboard';

const ErrorPage = React.lazy(() => import('src/pages/error/404'));
// ----------------------------------------------------------------------

export function Router() {
  return useRoutes([
    // Auth
    ...authRoutes,

    // Dashboard
    ...dashboardRoutes,

    // Error
    { path: '/404', element: <ErrorPage /> },

    // No match
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
